import { BLOTTER_PANEL_TABS_MIGRATION_VERSION, shouldRunBlotterTabsMigration } from '../../blotterTabsMigrationVersion';
import { migrateBalancesBlotterTabsToPanelParams } from './migrateBalancesBlotterTabsToPanelParams';
import { migrateCreditBlotterTabsToPanelParams } from './migrateCreditBlotterTabsToPanelParams';
import { migrateHedgePositionStatusTabsToPanelParams } from './migrateHedgePositionStatusTabsToPanelParams';
import { migrateLoansBlotterTabsToPanelParams } from './migrateLoansBlotterTabsToPanelParams';
import { migrateOrdersBlotterTabsToPanelParams } from './migrateOrdersBlotterTabsToPanelParams';
import { migrateOTCDerivativesBlotterTabsToPanelParams } from './migrateOTCDerivativesBlotterTabsToPanelParams';
import { migratePositionsBlotterTabsToPanelParams } from './migratePositionsBlotterTabsToPanelParams';
import { migrateReconMismatchesTabsToPanelParams } from './migrateReconMismatchesTabsToPanelParams';
import { migrateRFQsBlotterTabsToPanelParams } from './migrateRFQsBlotterTabsToPanelParams';
import { migrateTradeAllocationsTabsToPanelParams } from './migrateTradeAllocationsTabsToPanelParams';
import { migrateTradesBlotterTabsToPanelParams } from './migrateTradesBlotterTabsToPanelParams';
import { migrateTransfersBlotterTabsToPanelParams } from './migrateTransfersBlotterTabsToPanelParams';

/** Moves legacy blotter tabs into dockview panel params for each blotter type. [UI-5293] */
export function migrateBlotterTabsToPanelParams(replacedConfig: Record<string, any>) {
  // Check migration version to avoid running the migration if it's already been run
  if (!shouldRunBlotterTabsMigration(replacedConfig)) {
    return;
  }

  migrateBalancesBlotterTabsToPanelParams(replacedConfig);
  migrateCreditBlotterTabsToPanelParams(replacedConfig);
  migrateHedgePositionStatusTabsToPanelParams(replacedConfig);
  migrateLoansBlotterTabsToPanelParams(replacedConfig);
  migrateOTCDerivativesBlotterTabsToPanelParams(replacedConfig);
  migrateOrdersBlotterTabsToPanelParams(replacedConfig);
  migratePositionsBlotterTabsToPanelParams(replacedConfig);
  migrateReconMismatchesTabsToPanelParams(replacedConfig);
  migrateRFQsBlotterTabsToPanelParams(replacedConfig);
  migrateTradesBlotterTabsToPanelParams(replacedConfig);
  migrateTradeAllocationsTabsToPanelParams(replacedConfig);
  migrateTransfersBlotterTabsToPanelParams(replacedConfig);

  replacedConfig.blotterTabsMigrationVersion = BLOTTER_PANEL_TABS_MIGRATION_VERSION;
}
